import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-password-warning-modal',
    templateUrl: './password-warning-modal.component.html',
    styleUrls: ['./password-warning-modal.component.css'],
    standalone: false
})
export class PasswordWarningModalComponent {
  constructor(
    private router: Router,
    public activeModal: NgbActiveModal
  ) {}

  changePassword() {
    this.activeModal.close();
    this.router.navigate(['/account/changeaccountpassword'], { queryParams: {}, fragment: '/UA=F/Reset=T' });
  }
}
